App.addModule(function(app) {

    app.on('loaded', () => {
        
        const trustbadge = $('#trustbadge');
        
        const shop_id = app.getConfig('sales/trustedshops/shop_id');
        
        if (!(app.getConfigFlag('sales/trustedshops/active') && shop_id && trustbadge[0]) || trustbadge.children().length > 0) {
	        return;
        }
	    
	    app.onConsent('trustbadge', function() {
		    
        	window._tsConfig = { 
		        'yOffset': '0',
			    'variant': 'custom_reviews', /* text, default, small, reviews, custom, custom_reviews */
			    'customElementId': 'trustbadge',
			    'trustcardDirection': '', /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */
			    'disableResponsive': 'true',
			    'disableTrustbadge': BS.isScreenXs() && 'true' || 'false',
			    'trustCardTrigger': 'mouseenter'
		    };
            
		    $.ajax({
			    url: '//widgets.trustedshops.com/js/'+ shop_id +'.js',
			    cache: true,
			    crossDomain: true,
			    dataType: 'script'
		    });
	    });
    })
})
